import {
  LanguageReducer
} from './languageSlice';

const getLanguage = (state: LanguageReducer) => state.language;

export const languageSelectors = {
  getLanguage,
};
